import { FilterConfig } from 'interfaces/collection-filter';

/**
 * Check if a product matches the filter criteria for a specific filter group
 * Uses the same logic as the main collection filtering
 */
export const checkIfProductCorresponds = (
  productTags: string[],
  filterGroup: string,
  assignedFilter: { [key: string]: string[] },
  config: FilterConfig
): boolean => {
  // if this filter group has no active filters, then it's okay to show
  if (!assignedFilter[filterGroup]?.length) return true;

  // Always use OR logic for 'line' filter group
  if (filterGroup === 'line') {
    return assignedFilter[filterGroup].some((filter) => productTags.includes(filter));
  }

  // AND Filter
  if (config[filterGroup]?.compare === 'AND') {
    return assignedFilter[filterGroup].every((filter) => productTags.includes(filter));
  }

  // OR filter (default behavior)
  return assignedFilter[filterGroup].some((filter) => productTags.includes(filter));
};
